import { setGeoHashCount, getBulkStoreStatus } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import geoLocation from '@kfc-global/react-shared/utils/geoLocation.js';
import { ChannelManager } from 'common/manager';
import { createBasketData, getDispositionTypeOnAPIFormat, setSearchStoreByAtrribute } from 'common/utilities/utils';
import {
  checkNearBystoresData,
  setNewDisposition,
  updateCurrentStoreInfo,
} from 'organisms/SearchStore/SearchStoreUtilities/AutoDetectionUtils';
import { createBasketsAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import { ASAP, OPEN } from 'common/constants/SharedConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';

export const getNearbyStores = (
  lat,
  lon,
  boundingBoxSizeMeters,
  boundingBoxSizeDivider,
  geohashprecision,
  dispatch,
) => {
  const calculateGHPayload = {
    lat: lat,
    lon: lon,
    distanceFromCurrentLoc: boundingBoxSizeMeters / boundingBoxSizeDivider,
    geohashprecision: geohashprecision,
  };
  const geoHash = geoLocation?.calculateGH(calculateGHPayload);
  dispatch(setGeoHashCount(geoHash?.length));
};
export const AutoNearBystoreResponse = storeParam => {
  const {
    allStores,
    maxDistance,
    dispositionType,
    setActiveDisposition,
    distanceMetrics,
    maxDriveTimeMins,
    dispatch,
    tenantId,
    SetLocationClickHandler,
  } = storeParam;
  setActiveDisposition(dispositionType);
  const validatedNearBystoresData = checkNearBystoresData(allStores);
  //calculate linear Distance
  const linearDistancePayload = {
    stores: validatedNearBystoresData,
    disposition: dispositionType,
    distanceMetrics: distanceMetrics,
    driveTime: maxDriveTimeMins,
    distanceInMtrs: maxDistance,
    noOfStores: validatedNearBystoresData.length,
    channel: ChannelManager.channel,
  };
  const storesWithLinearDistance = geoLocation?.checkAndProceed(linearDistancePayload);
  if (storesWithLinearDistance?.length) {
    callStatusAPI(storesWithLinearDistance, dispositionType, dispatch, tenantId);
  } else {
    SetLocationClickHandler();
  }
};
export const callStatusAPI = (storeList, serviceType, dispatch, tenantId) => {
  const dataList = storeList?.map(store => {
    return { storeId: store.id, channel: ChannelManager.channel, service: serviceType };
  });
  const statusCallPayload = {
    data: dataList,
    store: storeList,
    tenantId: tenantId,
    setStatusFlag: false,
    isFavoritePage: false,
  };
  dispatch(getBulkStoreStatus(statusCallPayload));
};
export const getLocalized = async ({
  finalStore,
  dispositionNew,
  activeDisposition,
  userOrderState,
  profileReducer,
  dispatch,
  tenantId,
  userOrderStateDispatch,
  userParams,
  tenantReducer,
  setAutoDetectFlow,
}) => {
  let dateTimeObj = {
    time: ASAP,
    interval: finalStore.summary.timings.scheduled.periods[0]?.interval,
    date: new Date(),
    selectedTime: ASAP,
  };
  let obj = await createBasketData(
    finalStore,
    getDispositionTypeOnAPIFormat(activeDisposition),
    profileReducer?.customerId,
    dateTimeObj,
  );
  dispatch(createBasketsAction({ data: obj, tenantId: tenantId }));

  setNewDisposition(dispositionNew, userOrderStateDispatch, userOrderState, activeDisposition, finalStore, dateTimeObj);

  let store = finalStore ? finalStore : null;
  dispatch(
    setUserParams({
      ...userParams,
      localized: true,
    }),
  );

  updateCurrentStoreInfo(userOrderStateDispatch, activeDisposition, dateTimeObj, store, tenantReducer);
  setAutoDetectFlow(false);
  setSearchStoreByAtrribute();
};
export const filterStatusResponse = storeObj => {
  const {
    storesWithStatus,
    dispositionNew,
    setAutoDetectFlow,
    activeDisposition,
    userOrderState,
    profileReducer,
    dispatch,
    tenantId,
    userOrderStateDispatch,
    userParams,
    tenantReducer,
    SetLocationClickHandler,
  } = storeObj;
  const localized = userParams?.localized;
  const finalStores = storesWithStatus?.filter(store => {
    return (
      store?.id &&
      store?.location?.latitude &&
      store?.location?.longitude &&
      store?.summary?.status?.currentStatus === OPEN &&
      store?.summary?.menu?.catalogs?.length &&
      store?.summary?.timings?.operatingHours?.length > 0 &&
      store?.summary?.timings?.asap
    );
  });
  if (finalStores?.length > 0) {
    if (localized) {
      if (dispositionNew) {
        setAutoDetectFlow(false);
      }
    } else {
      getLocalized({
        finalStore: finalStores[0],
        dispositionNew,
        activeDisposition,
        userOrderState,
        profileReducer,
        dispatch,
        tenantId,
        userOrderStateDispatch,
        userParams,
        tenantReducer,
        setAutoDetectFlow,
      });
      userOrderStateDispatch({ type: START_ORDER_CONSTANTS.DISPOSITION_DATA, value: { showDisposition: false } });
    }
  } else {
    setAutoDetectFlow(false);
    SetLocationClickHandler();
  }
};
